import React, { ReactNode } from 'react'
import { ScreenReaderOnly, ScreenReaderOnlyAs } from '../screen-reader-only/screen-reader-only'
import { StyledFieldsetPanel, StyledFieldsetPanelLegend } from './fieldset-panel.styles'

interface FieldsetPanelProps {
    children: ReactNode
    compact?: boolean
    singularColumn?: boolean
    singularColumnSmall?: boolean
    srOnly?: boolean
    title?: string
}
export const FieldsetPanel = ({
    title,
    srOnly = false,
    singularColumnSmall = false,
    singularColumn,
    compact = false,
    children,
}: FieldsetPanelProps) => {
    return (
        <StyledFieldsetPanel
            hasTitle={!!title && !srOnly}
            singularColumn={singularColumn}
            singularColumnSmall={singularColumnSmall}
            compact={compact}
        >
            {srOnly && title && <ScreenReaderOnly id={title} description={title} typeAs={ScreenReaderOnlyAs.LEGEND} />}
            {!srOnly && title && <StyledFieldsetPanelLegend as="legend">{title}</StyledFieldsetPanelLegend>}
            {children}
        </StyledFieldsetPanel>
    )
}
